import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import TextAreaItem from "../../../components/formItems/TextAreaItem";
import RadioButtonItem from "../../../components/formItems/RadioButtonItem";
import PredefinedSelectItem from "../../../components/formItems/PredefinedSelectItem";

const Summary = (props) => {
  const intl = useIntl();
  const {
    activeHouseVisit,
    changedValues,
    approved,
    control,
    loading,
    enabled,
    futureVisit,
    userIsProOrAdmin,
  } = props;

  const isApproved =
    changedValues.approved !== undefined
      ? changedValues.approved
      : activeHouseVisit.approved;

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.summary",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <TextAreaItem
          name="report__summary_and_recommendations"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.summary_and_recommendations",
          })}
          disabled={approved || !enabled}
          loading={loading}
          autoGrow={true}
        />
        <RadioButtonItem
          name="approved"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.approved",
          })}
          disabled={!enabled || futureVisit}
          trueFalse={true}
          loading={loading}
        />
        {isApproved === false && (
          <div style={{ flex: 1 }}>
            <PredefinedSelectItem
              name="reason_not_approved"
              control={control}
              label={intl.formatMessage({
                id: "app.mobile.forms.house_visits.reason_not_approved",
              })}
              params={{
                name: "meta/system_tables/house_visits/complains_feedback",
              }}
              reasonNotApproved={true}
              disabled={approved || !enabled}
              loading={loading}
            />
          </div>
        )}
        {userIsProOrAdmin && (
          <RadioButtonItem
            name="verified"
            control={control}
            label={intl.formatMessage({
              id: "app.mobile.forms.house_visits.verified",
            })}
            trueFalse={true}
            disabled={
              (activeHouseVisit.verified && !activeHouseVisit.can_unverify) ||
              futureVisit
            }
            loading={loading}
          />
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default Summary;
